import { Type } from 'class-transformer';
import { Qualification } from './qualification';

export class QualificationAggregate {
    readonly id: string;
    readonly label: string;

    @Type(() => Date)
    readonly since: Date;

    @Type(() => Date)
    readonly until: Date;

    @Type(() => Qualification)
    readonly qualifications: Qualification[];
}
